const iframeClassNames = {
  INLINE_IFRAME_CONTENT: "sid-inline-iframe",
  MODAL_WRAPPER: "sid-modal__wrapper",
  MODAL_IFRAME: "sid-modal__iframe",
  OVERLAY: "sid-modal__overlay",
  CLOSE_BUTTON: "sid-modal__close-button",
  CLOSE_TEXT: "sid-modal__close-text",
  CLOSE_ICON: "sid-modal__close-icon",
};

export const iframeTitle = "SheerID Verification Form";

export const iframeConstants = {
  CLASS_NAMES: iframeClassNames,
  DEFAULT_MOBILE_THRESHOLD_WIDTH: 620,
  MODAL_OPACITY_TRANSITION_PERIOD: 300,
};
